import type { IxcPortfolioV1HoldKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const getPortfolioHoldPath: EntityPathBuilder<IxcPortfolioV1HoldKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      if (!context?.keys) {
        return undefined;
      }

      return getResolvedPath('/registration/account/$accountId/hold', context.keys);
    case 'detail': {
      if (!context?.keys?.holdId) {
        return undefined;
      }

      return getResolvedPath('/registration/account/$accountId/hold/$holdId', context.keys);
    }
  }
};

export function getPortfolioHoldDetailPath(accountId: string | undefined, holdId: string | undefined) {
  if (!accountId || !holdId) {
    return undefined;
  }

  return getPortfolioHoldPath({ kind: 'detail', keys: { accountId, holdId } });
}
